/* Panel PDP only: start a gallery video when its selected slide is on screen. */
(() => {
  const sectionSelector = '.product-information';
  const gallerySelector = 'media-gallery.media-gallery--carousel';
  const observed = new WeakSet();
  const visibility = new WeakMap();
  const selected = new WeakMap();
  // A touch tap emits slideshow:select even when the slide did not change.
  // Autoplay only on activation; leave subsequent play/pause to the native control.
  const activeMedia = new WeakMap();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const gallery = entry.target;
      visibility.set(gallery, entry.isIntersecting && entry.intersectionRatio >= 0.15);
      sync(gallery);
    }
  }, { threshold: [0, 0.15, 0.5] });

  /** @param {HTMLElement} gallery */
  function sync(gallery) {
    const slide = selected.get(gallery) || gallery.querySelector('slideshow-component slideshow-slide[aria-hidden="false"]');
    const visible = visibility.get(gallery) && !document.hidden;
    for (const deferred of gallery.querySelectorAll('slideshow-component slideshow-slide deferred-media')) {
      if (!visible || !slide?.contains(deferred) || !deferred.closest('.product-media-container--video')) {
        if (activeMedia.get(gallery) === deferred) activeMedia.delete(gallery);
        if (deferred.querySelector('video')) deferred.pauseMedia?.();
        continue;
      }
      if (activeMedia.get(gallery) === deferred) continue;
      // No hidden slide is loaded or played. The poster remains the manual fallback.
      if (!deferred.querySelector('video')) deferred.loadContent?.(false);
      const video = deferred.querySelector('video');
      if (!video) continue;
      activeMedia.set(gallery, deferred);
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('muted', '');
      video.play().then(() => {
        deferred.isPlaying = true;
        deferred.updatePlayPauseHint?.(true);
      }).catch(() => {
        // Browser policy or network can block autoplay; retain the native play toggle.
        deferred.pauseMedia?.();
      });
    }
  }

  function attach() {
    for (const gallery of document.querySelectorAll(`${sectionSelector} ${gallerySelector}`)) {
      if (observed.has(gallery)) continue;
      observed.add(gallery);
      observer.observe(gallery);
    }
  }
  document.addEventListener('slideshow:select', (event) => {
    const gallery = event.target.closest(gallerySelector);
    if (!gallery?.closest(sectionSelector)) return;
    selected.set(gallery, event.detail.slide);
    sync(gallery);
  });
  document.addEventListener('visibilitychange', () => {
    document.querySelectorAll(`${sectionSelector} ${gallerySelector}`).forEach(sync);
  });
  new MutationObserver(attach).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
  else attach();
})();
